<template>
  <Select
    :items="arrayTipos"
    :selectedItem="filter.tipo_cfop"
    :label="$i18n('interface.novo_filtro.tipo_cfop')"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_tipo_cfop')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        tipo_cfop: {
          id: "",
          name: "",
        },
      },
      arrayTipos: [
        { id: "CEO", name: "Conta e ordem" },
        { id: "CO", name: "Compra direta no mercado interno" },
      ],
    };
  },
  methods: {
    atualizar(tipo) {
      this.filter.tipo_cfop = tipo || { id: "", name: "" };

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.tipo_cfop.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.tipo_cfop.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayTipos, this.filter.tipo_cfop);
  },
}
</script>
